import type { DateTime } from "luxon";
import type {
  ArticleDetailed,
  HostingTariff,
  MachineType,
  MachineTypeOptimization,
} from "../../article/index.js";
import type { ContractDetailed } from "./Contract.js";
import invariant from "invariant";
import type { Customer } from "../../customer/index.js";

export class HostingConfiguration {
  public readonly storage: number;
  public readonly machineType: MachineType;
  public readonly vcpu: number;
  public readonly ram: number;
  public readonly tariff: HostingTariff;
  public readonly nextPossibleDowngradeDate?: DateTime;
  public readonly nextPossibleUpgradeDate?: DateTime;
  public readonly customer: Customer;
  public readonly machineTypeOptimization?: MachineTypeOptimization;
  public constructor(article: ArticleDetailed, contract: ContractDetailed) {
    invariant(article.storage, "storage not found");
    const storageAmount =
      contract.baseItemArticles.find((a) => a.data.id.includes("Storage"))
        ?.amount ?? 0;
    this.storage = article.storage * (storageAmount + 1);

    invariant(article.machineType, "machineType not found");
    this.machineType = article.machineType as MachineType;

    invariant(article.vcpu, "vcpu not found");
    this.vcpu = article.vcpu;

    invariant(article.ram, "ram not found");
    this.ram = article.ram;

    this.machineTypeOptimization = article.machineTypeOptimization;
    this.tariff = article.name as HostingTariff;
    this.nextPossibleDowngradeDate = contract.nextPossibleDowngradeDate;
    this.nextPossibleUpgradeDate = contract.nextPossibleUpgradeDate;
    this.customer = contract.customer;
  }
}
